export default (list, property, values) =>
  list.filter((item) => !values.includes(item[property]));
